import { pendingTask, begin, end } from 'react-redux-spinner';
import toastr from 'toastr';
import * as Types from '../action-types';
import PricingService from '../../services/pricing-service';
import serviceUtils from '../../utils/service-utils';

let hotelSearchActions = {
    selectAllHotels: function(selectAll) {
        return {
            type: Types.SELECT_ALL_HOTELS,
            response: { selectAll: selectAll }
        };
    },
    changeHotelSelection: function(hotel, index) {
        return {
            type: Types.CHANGE_HOTEL_SELECTION,
            response: { hotel: hotel, index: index }
        };
    },
    search: function(filters) {
        return (dispatch, getState) => {
            dispatch(hotelSearchActions.searchBegin());
            let service = new PricingService(getState().oidc.user !== null ? getState().oidc.user.id_token : '');
            return service.searchPricingHotels(filters)
                .then((response) => {
                    return serviceUtils.checkForFetchServerError(response,'Server Error : Unable to contact the inventory web service.');
                })
                .then((data) => {
                    dispatch(hotelSearchActions.searchSuccess(data));
                    return data;
                })
                .catch((error) => { 
                    toastr.error('Error searching records');
                    dispatch(hotelSearchActions.searchError(error));
                    throw (error); 
                });
        };
    },
    searchBegin: function() {
        return {
            type: Types.SEARCH_BEGIN,
            [ pendingTask ]: begin
        };
    },
    searchSuccess: function(data) {
        return {
            type: Types.SEARCH_SUCCESS,
            response: data,
            [ pendingTask ]: end
        };
    },
    searchError: function(error) {
        return {
            type: Types.SEARCH_ERROR,
            error: error,
            [ pendingTask ]: end
        };
    }
}

export default hotelSearchActions;
